import * as tokens from '../../../../../tokens/color.light.generated.js';
export const componentColorLight = {
    color: {
        feedback: {
            progressIndicator: {
                monochrome: {
                    surface: {
                        trainLine: {
                            default: tokens.CMP_COLOR_FEEDBACK_PROGRESS_INDICATOR_MONOCHROME_SURFACE_TRAIN_LINE_DEFAULT_LIGHT
                        },
                        trackLine: {
                            default: tokens.CMP_COLOR_FEEDBACK_PROGRESS_INDICATOR_MONOCHROME_SURFACE_TRACK_LINE_DEFAULT_LIGHT
                        }
                    }
                },
                inverted: {
                    surface: {
                        trainLine: {
                            default: tokens.CMP_COLOR_FEEDBACK_PROGRESS_INDICATOR_INVERTED_SURFACE_TRAIN_LINE_DEFAULT_LIGHT
                        },
                        trackLine: {
                            default: tokens.CMP_COLOR_FEEDBACK_PROGRESS_INDICATOR_INVERTED_SURFACE_TRACK_LINE_DEFAULT_LIGHT
                        }
                    }
                }
            }
        },
        action: {
            toggleButton: {
                indicator: {
                    default: tokens.CMP_COLOR_ACTION_TOGGLE_BUTTON_INDICATOR_DEFAULT_LIGHT
                }
            },
            iconButton: {
                primary: {
                    foreground: {
                        text: {
                            default: tokens.CMP_COLOR_ACTION_ICON_BUTTON_PRIMARY_FOREGROUND_TEXT_DEFAULT_LIGHT,
                            hover: tokens.CMP_COLOR_ACTION_ICON_BUTTON_PRIMARY_FOREGROUND_TEXT_HOVER_LIGHT,
                            pressed: tokens.CMP_COLOR_ACTION_ICON_BUTTON_PRIMARY_FOREGROUND_TEXT_PRESSED_LIGHT,
                            disabled: tokens.CMP_COLOR_ACTION_ICON_BUTTON_PRIMARY_FOREGROUND_TEXT_DISABLED_LIGHT
                        }
                    }
                },
                secondary: {
                    foreground: {
                        text: {
                            default: tokens.CMP_COLOR_ACTION_ICON_BUTTON_SECONDARY_FOREGROUND_TEXT_DEFAULT_LIGHT,
                            hover: tokens.CMP_COLOR_ACTION_ICON_BUTTON_SECONDARY_FOREGROUND_TEXT_HOVER_LIGHT,
                            pressed: tokens.CMP_COLOR_ACTION_ICON_BUTTON_SECONDARY_FOREGROUND_TEXT_PRESSED_LIGHT,
                            disabled: tokens.CMP_COLOR_ACTION_ICON_BUTTON_SECONDARY_FOREGROUND_TEXT_DISABLED_LIGHT
                        }
                    }
                },
                tertiary: {
                    foreground: {
                        text: {
                            default: tokens.CMP_COLOR_ACTION_ICON_BUTTON_TERTIARY_FOREGROUND_TEXT_DEFAULT_LIGHT,
                            hover: tokens.CMP_COLOR_ACTION_ICON_BUTTON_TERTIARY_FOREGROUND_TEXT_HOVER_LIGHT,
                            pressed: tokens.CMP_COLOR_ACTION_ICON_BUTTON_TERTIARY_FOREGROUND_TEXT_PRESSED_LIGHT,
                            disabled: tokens.CMP_COLOR_ACTION_ICON_BUTTON_TERTIARY_FOREGROUND_TEXT_DISABLED_LIGHT
                        }
                    }
                }
            }
        },
        navigation: {
            textLink: {
                foreground: {
                    disabled: tokens.CMP_COLOR_NAVIGATION_TEXT_LINK_FOREGROUND_DISABLED_LIGHT,
                    default: tokens.CMP_COLOR_NAVIGATION_TEXT_LINK_FOREGROUND_DEFAULT_LIGHT,
                    interactive: tokens.CMP_COLOR_NAVIGATION_TEXT_LINK_FOREGROUND_INTERACTIVE_LIGHT
                }
            }
        },
        forms: {
            extendedSelection: {
                surface: {
                    stroke: {
                        error: tokens.CMP_COLOR_FORMS_EXTENDED_SELECTION_SURFACE_STROKE_ERROR_LIGHT,
                        disabled: tokens.CMP_COLOR_FORMS_EXTENDED_SELECTION_SURFACE_STROKE_DISABLED_LIGHT,
                        default: tokens.CMP_COLOR_FORMS_EXTENDED_SELECTION_SURFACE_STROKE_DEFAULT_LIGHT,
                        interactive: tokens.CMP_COLOR_FORMS_EXTENDED_SELECTION_SURFACE_STROKE_INTERACTIVE_LIGHT
                    }
                }
            },
            slider: {
                surface: {
                    handle: {
                        default: tokens.CMP_COLOR_FORMS_SLIDER_SURFACE_HANDLE_DEFAULT_LIGHT,
                        disabled: tokens.CMP_COLOR_FORMS_SLIDER_SURFACE_HANDLE_DISABLED_LIGHT
                    },
                    track: {
                        default: tokens.CMP_COLOR_FORMS_SLIDER_SURFACE_TRACK_DEFAULT_LIGHT
                    },
                    steps: {
                        default: tokens.CMP_COLOR_FORMS_SLIDER_SURFACE_STEPS_DEFAULT_LIGHT
                    },
                    progress: {
                        default: tokens.CMP_COLOR_FORMS_SLIDER_SURFACE_PROGRESS_DEFAULT_LIGHT,
                        interactive: tokens.CMP_COLOR_FORMS_SLIDER_SURFACE_PROGRESS_INTERACTIVE_LIGHT,
                        disabled: tokens.CMP_COLOR_FORMS_SLIDER_SURFACE_PROGRESS_DISABLED_LIGHT,
                        error: tokens.CMP_COLOR_FORMS_SLIDER_SURFACE_PROGRESS_ERROR_LIGHT
                    }
                }
            },
            toggle: {
                inactive: {
                    surface: {
                        default: tokens.CMP_COLOR_FORMS_TOGGLE_INACTIVE_SURFACE_DEFAULT_LIGHT,
                        interactive: tokens.CMP_COLOR_FORMS_TOGGLE_INACTIVE_SURFACE_INTERACTIVE_LIGHT,
                        disabled: tokens.CMP_COLOR_FORMS_TOGGLE_INACTIVE_SURFACE_DISABLED_LIGHT,
                        handle: {
                            default: tokens.CMP_COLOR_FORMS_TOGGLE_INACTIVE_SURFACE_HANDLE_DEFAULT_LIGHT
                        }
                    }
                },
                active: {
                    surface: {
                        default: tokens.CMP_COLOR_FORMS_TOGGLE_ACTIVE_SURFACE_DEFAULT_LIGHT,
                        disabled: tokens.CMP_COLOR_FORMS_TOGGLE_ACTIVE_SURFACE_DISABLED_LIGHT
                    }
                }
            }
        },
        ui: {
            tag: {
                foreground: {
                    icons: {
                        default: tokens.CMP_COLOR_UI_TAG_FOREGROUND_ICONS_DEFAULT_LIGHT
                    },
                    text: {
                        default: tokens.CMP_COLOR_UI_TAG_FOREGROUND_TEXT_DEFAULT_LIGHT
                    }
                },
                surface: {
                    fill: {
                        default: tokens.CMP_COLOR_UI_TAG_SURFACE_FILL_DEFAULT_LIGHT
                    }
                },
                selected: {
                    foreground: {
                        text: {
                            default: tokens.CMP_COLOR_UI_TAG_SELECTED_FOREGROUND_TEXT_DEFAULT_LIGHT,
                            disabled: tokens.CMP_COLOR_UI_TAG_SELECTED_FOREGROUND_TEXT_DISABLED_LIGHT
                        }
                    },
                    surface: {
                        fill: {
                            default: tokens.CMP_COLOR_UI_TAG_SELECTED_SURFACE_FILL_DEFAULT_LIGHT,
                            hover: tokens.CMP_COLOR_UI_TAG_SELECTED_SURFACE_FILL_INTERACTIVE_LIGHT,
                            disabled: tokens.CMP_COLOR_UI_TAG_SELECTED_SURFACE_FILL_DISABLED_LIGHT
                        }
                    }
                },
                unselected: {
                    foreground: {
                        icons: {
                            default: tokens.CMP_COLOR_UI_TAG_UNSELECTED_FOREGROUND_ICONS_DEFAULT_LIGHT,
                            hover: tokens.CMP_COLOR_UI_TAG_UNSELECTED_FOREGROUND_ICONS_INTERACTIVE_LIGHT
                        },
                        text: {
                            default: tokens.CMP_COLOR_UI_TAG_UNSELECTED_FOREGROUND_TEXT_DEFAULT_LIGHT,
                            disabled: tokens.CMP_COLOR_UI_TAG_UNSELECTED_FOREGROUND_TEXT_DISABLED_LIGHT
                        }
                    },
                    surface: {
                        stroke: {
                            default: tokens.CMP_COLOR_UI_TAG_UNSELECTED_SURFACE_STROKE_DEFAULT_LIGHT,
                            hover: tokens.CMP_COLOR_UI_TAG_UNSELECTED_SURFACE_STROKE_INTERACTIVE_LIGHT,
                            disabled: tokens.CMP_COLOR_UI_TAG_UNSELECTED_SURFACE_STROKE_DISABLED_LIGHT
                        },
                        fill: {
                            default: tokens.CMP_COLOR_UI_TAG_UNSELECTED_SURFACE_FILL_DEFAULT_LIGHT,
                            hover: tokens.CMP_COLOR_UI_TAG_UNSELECTED_SURFACE_FILL_INTERACTIVE_LIGHT,
                            disabled: tokens.CMP_COLOR_UI_TAG_UNSELECTED_SURFACE_FILL_DISABLED_LIGHT
                        }
                    }
                }
            }
        }
    }
};
//# sourceMappingURL=color.light.js.map